import { render, staticRenderFns } from "./NominateReviewers.vue?vue&type=template&id=5f44033f&scoped=true&"
import script from "./NominateReviewers.vue?vue&type=script&lang=js&"
export * from "./NominateReviewers.vue?vue&type=script&lang=js&"
import style0 from "./NominateReviewers.vue?vue&type=style&index=0&id=5f44033f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44033f",
  null
  
)

export default component.exports